import { AuthFailure, AuthSystem, IAuthenticationAnalyticsContext } from '@pressreader/authentication-types';

import { IEvent } from 'eventbus/events';

import { AuthenticationType } from '../authenticationtypes';

enum EventTypes {
    SignInRequested = '[Authentication] SignIn',
    SignInSucceeded = '[Authentication] SignInSucceeded',
    SignInFailed = '[Authentication] SignInFailed',

    SignUpRequested = '[Authentication] SignUp',
    SignUpSucceeded = '[Authentication] SignUpSucceeded',
    SignUpFailed = '[Authentication] SignUpFailed',

    AccountChanged = '[Authentication] Account Changed',

    SignUpEmailAlertSet = '[Authentication] SignUpEmailAlertSet',
}

enum EmailAlertTypes {
    EmailAlertPromotional = 'EmailAlerts.Promotional',
    EmailAlertTechnical = 'EmailAlerts.Technical',
}

class SignInRequestedEvent implements IEvent {
    readonly type = EventTypes.SignInRequested;

    constructor(public payload: { system: AuthenticationType }) {}
}

class SignInSucceededEvent implements IEvent {
    readonly type = EventTypes.SignInSucceeded;

    constructor(public payload: { system: AuthenticationType }) {}
}

class SignInFailedEvent implements IEvent {
    readonly type = EventTypes.SignInFailed;

    constructor(
        public payload: {
            system: AuthenticationType;
            /** The system analytics reports when it differs from `system`, whose page view path stays as it was. */
            analyticsSystem?: AuthSystem;
            failure?: AuthFailure;
            provider?: string;
            libraryId?: number;
            analyticsCtx?: IAuthenticationAnalyticsContext;
        },
    ) {}
}

class SignUpRequestedEvent implements IEvent {
    readonly type = EventTypes.SignUpRequested;

    constructor(public payload: { system: AuthenticationType }) {}
}

class SignUpSucceededEvent implements IEvent {
    readonly type = EventTypes.SignUpSucceeded;

    constructor(public payload: { system: AuthenticationType }) {}
}

class SignUpFailedEvent implements IEvent {
    readonly type = EventTypes.SignUpFailed;

    constructor(public payload: { system: AuthenticationType }) {}
}

class AccountChangedEvent implements IEvent {
    readonly type = EventTypes.AccountChanged;

    constructor(public payload?: unknown) {}
}

class SignUpEmailAlertSetEvent implements IEvent {
    readonly type = EventTypes.SignUpEmailAlertSet;

    constructor(public payload: { alertKey: EmailAlertTypes; value: boolean; isDefault: boolean }) {}
}

export {
    AccountChangedEvent,
    EmailAlertTypes,
    EventTypes,
    SignInFailedEvent,
    SignInRequestedEvent,
    SignInSucceededEvent,
    SignUpEmailAlertSetEvent,
    SignUpFailedEvent,
    SignUpRequestedEvent,
    SignUpSucceededEvent,
};
